export default __webpack_public_path__ + "static/media/cap.41e59db3.svg";